import Button from '../../components/elements/Button';
import React, { useState, useEffect, Fragment } from 'react';
import useAuthApi from '../../hooks/useAuthApi'
import useAuthToken from '../../hooks/useAuthToken';
import { useHistory } from "react-router-dom";

function DeletionActions(props) {
  const history = useHistory();
  const { clearToken } = useAuthToken();
  const authApi = useAuthApi();
  const [hipaaConsented, setHipaaConsented] = useState(false);

  useEffect(() => {
    checkConsent();
  }, [props.userId]);

  const checkConsent = () => {
    authApi.get('users/users/' + props.userId + '/check_consent').then(data => {
      setHipaaConsented(data.data.attributes.hipaa_consented);
    }).catch(console.log);
  }

  function deleteAccount() {
    authApi.delete('users/users/' + props.userId)
    .then((data) => {
      console.log(data);
      clearToken();
      history.push({
        pathname: "/signin" });
      window.scrollTo(0, 0);
    }).catch(console.log);
  }

  const DeleteAccountElement = () => {
    return(
      <div className='settings__deletion-section'>
        <p>Deleting your account will remove all account history and data, and will be permanent.</p>
        <Button 
          label="Delete My Account"
          active={true}
          class="long-btn text-btn"
          onClick={() => deleteAccount()}
        />
      </div>
    );
  }

  function updateConsent() {
    var updateRequest = {hipaa_consented: !hipaaConsented} ;

    authApi.patch_json(
      'users/users/' + props.userId,
      { user: updateRequest }
    )
    .then((data) => {
      setHipaaConsented(data.data.attributes.hipaa_consented);
    }).catch(console.log);
  }

  const HipaaConsentElement = () => {
    var buttonLabel = hipaaConsented == true ? "Revoke My Hippa Consent" : "Invoke My Hippa Consent"
    return (
      <div className='settings__deletion-section'>
        <p>Your health data and whatever about HIPPAA consent beepbopboop delete your stuff</p>
        <Button 
          label={buttonLabel}
          active={true}
          class="long-btn text-btn"
          onClick={() => updateConsent()}
        />
      </div>
    )
  }

  return (
    <div className='settings__deletions'>
      {DeleteAccountElement()}
      
    </div>
  )

}

export default DeletionActions;
